<template>
  <div>
    <Modal class="jurisdictionBox" width="902" v-model="currentStatus" :closable="false" :mask-closable="false"
      :footer-hide="true">
      <!-- title -->
      <div class="title-header">
        <p>
          <span> {{popoutType==0?"企业":popoutType==1?"部门":popoutType==2?"部门角色":"用户"}}权限分配</span>
          <span class="iconfont ys-iconguanbi" @click="handleCancleClick(1)"></span>
        </p>
        <p v-if="popoutType==0">
          <span>企业名称: &nbsp;<i>{{explainInfo.dept_cn_name}}</i></span>
          <span>企业编码: &nbsp;<i>{{explainInfo.dept_id}}</i></span>
        </p>
        <p v-else-if="popoutType==1">
          <span>部门名称: &nbsp;<i>{{explainInfo.dept_cn_name}}</i></span>
          <span>部门编码: &nbsp;<i>{{explainInfo.dept_id}}</i></span>
        </p>
        <p v-else-if="popoutType==2">
          <span>角色部门名称: &nbsp;<i>{{explainInfo.bk_expl}}</i></span>
          <span>部门角色编码: &nbsp;<i>{{explainInfo.dprl_code}}</i></span>
          <span>部门:&nbsp; <i>{{explainInfo.dept_cn_name}}</i></span>
        </p>
        <p v-else>
          <span>用户名: &nbsp;<i>{{explainInfo.user_cn_name}}</i></span>
          <span>用户ID: &nbsp;<i>{{explainInfo.user_id}}</i></span>
          <span>部门:&nbsp; <i>{{explainInfo.dept_cn_name}}</i></span>
        </p>
      </div>
      <!-- tab切换 -->
      <div class="tab-list">
        <p class="ys-header" :class="index === 1 ? 'ys-header-active' : ''" @click="handleSourceClick(1)">菜单资源</p>
        <p v-if="popoutType==3" lass="ys-header" :class="index === 2 ? 'ys-header-active' : ''"
          @click="handleSourceClick(2)">按钮权限</p>
      </div>
      <!-- 折叠面板 -->
      <Collapse v-show="index === 1">
        <template v-if="MenuPermissionList && MenuPermissionList.length>0">
          <template v-for="(Pitem,Pindex) in MenuPermissionList">
            <Panel v-if="Pitem.children && Pitem.children.length>0" :key="Pindex" :name="Pitem.rs_code">
              {{Pitem.rs_cn_name}}
              <p slot="content">
                <Tree ref="menuTree" show-checkbox :data="Pitem.children"></Tree>
              </p>
            </Panel>
          </template>
        </template>
        <template v-else>
          <Spin>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </template>

      </Collapse>
      <Collapse v-show="index === 2" v-model="BtnVal">
        <template v-if="BtnPermissionList && BtnPermissionList.length>0">
          <template v-for="(Pitem,Pindex) in BtnPermissionList">
            <Panel v-if="Pitem.children && Pitem.children.length>0" :key="Pindex" :name="Pitem.rs_code">
              {{Pitem.rs_cn_name}}
              <p slot="content">
                <Tree ref="BtnTree" show-checkbox :data="Pitem.children"></Tree>
              </p>
            </Panel>
          </template>
        </template>
        <template v-else>
          <Spin>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </template>
      </Collapse>
      <!-- 按钮组 -->
      <div class="btnJurisdiction">
        <Button class="ys-cancel" @click="handleCancleClick(1)">取消</Button>&nbsp;&nbsp;
        <Button class="ys-confirm" @click="handleCancleClick(2)">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    props: {
      // 是否打开弹框
      currentStatus: {
        type: Boolean,
        defalut: false
      },
      // 打开弹框的类型  0 企业  1表示部门  2表示部门角色    3表示用户
      popoutType: {
        type: Number,
        default: 0,
      },
      // 菜单权限列表
      MenuPermissionList: {
        type: Array,
        default: () => {}
      },
      BtnPermissionList: {
        type: Array,
        default: () => {}
      },
      // 弹框头部说明信息
      explainInfo: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        BtnVal: 1, // 按钮面板默认选中值
        index: 1,
        resultBtnList: [], // 最终要存储的按钮权限数组
      }
    },
    methods: {
      handleSourceClick(options) {
        switch (options) {
          case 1:
            this.index = 1;
            break;
          case 2:
            this.index = 2;
            break;
          default:
            break;
        }
      },
      handleCancleClick(options) {
        switch (options) {
          case 1:
            this.$emit('on-jurisdiction-click', 1);
            break;
          case 2:
            this.$emit('on-jurisdiction-click', 2);
            this.getCheckedAndIndeterminateNodes_Menu();
            break;
          default:
            break;
        }
      },
      // 获取菜单权限选中及半选节点
      getCheckedAndIndeterminateNodes_Menu() {
        // 最终要存储的菜单权限数组
        let resultMenuList = [];
        // 因为这里的项目是循环出来的  所有获取到的是个数组结构
        let MenuTreeList = this.$refs.menuTree;
        let BtnTreeList = this.$refs.BtnTree;
        // 整理菜单权限列表

        if (MenuTreeList && MenuTreeList.length > 0) {
          MenuTreeList.forEach(item => {
            let singleMenuList = this.disposeSelectMenuList(item.getCheckedAndIndeterminateNodes());
            if (singleMenuList.length > 0) {
              resultMenuList = resultMenuList.concat(singleMenuList);
            }
          });
        }
        // 整理按钮权限列表
        if (this.BtnPermissionList && this.BtnPermissionList.length > 0) {
          this.resultBtnList = [];
          this.disposeSelectBtnList(this.BtnPermissionList);
        }
        // 返回处理后的权限列表数据
        this.$emit("selectedPermissionList", resultMenuList, this.resultBtnList)
      },
      // 处理合并当前选中的菜单权限列表数据
      disposeSelectMenuList(menuList) {
        let singleProjectMenuList = [];
        if (menuList && menuList.length > 0) {
          menuList.forEach((item, index) => {
            // 如果是第一个  需要把顶级资源的ID加上
            if (index === 0) {
              singleProjectMenuList.push(item.bl_rs_code);
            }
            singleProjectMenuList.push(item.rs_code);
          });
        }
        return singleProjectMenuList;
      },
      // 处理合并当前未选中的按钮权限列表数据
      disposeSelectBtnList(btnList) {
        btnList.forEach(item => {
          // 判断有没有children
          if (item.children && item.children.length > 0) {
            this.disposeSelectBtnList(item.children);
          } else if (item.rs_level > 1 && !item.checked) {
            //获取没有选中的按钮列表
            this.resultBtnList = this.resultBtnList.concat([item.rs_code]);
          }
        });
      },
    }
  }
</script>
<style lang="less" scoped>
  .jurisdictionBox {
    width: 704px;
    background-color: #2F3D57;

    .title-header {
      width: 100%;

      p:nth-of-type(1) {
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin-bottom: 24px;

        span:nth-of-type(1) {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(179, 195, 226, 1);
        }

        span:nth-of-type(2) {
          font-size: 28px;
        }

        span:nth-of-type(2):hover {
          cursor: pointer;
        }
      }

      p:nth-of-type(2) {
        width: 100%;
        margin-bottom: 30px;

        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(179, 195, 226, 1);
          margin-right: 40px;

          i {
            font-style: normal;
          }
        }
      }
    }

    .tab-list {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;

      p {
        width: 102px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 6px 6px 0px 0px;
        font-family: PingFangSC-Regular, PingFang SC;
      }

      p:hover {
        cursor: pointer;
      }
    }

    .btnJurisdiction {
      width: 100%;
      text-align: right;
      margin-top: 24px;
    }
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>